import React, { useEffect, useState } from "react";
import tick from "../../assets/images/tick.png";
import cross from "../../assets/images/cross.png";
import EntryCard from "./entry-card";
import scan from "../../assets/images/scan.png";
import mannual from "../../assets/images/manual.png";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../../pages/preview/Drawing.module.scss";
import { Upload } from "@progress/kendo-react-upload";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { toast } from "react-toastify";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import axios from "axios";
import useModelStore from "../../store/model-store";
import usePreviewStore from "../../store/preview-store";
import { useRouter } from "../../pages/routes/hooks/use-router";
import { convertPngToJpeg } from "../../utils/file-converter";
const GutterSheet = ({ nextStep, leadDetail, isMobile }) => {
  const [uploadGutterSheet, setUploadGutterSheet] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const { modelData, setModelData } = useModelStore();
  useEffect(() => {
    setUploadGutterSheet(modelData.isGutterSheet);
    setSelectedType(modelData.gutterSheetUploadType);
  }, [modelData]);

  const navigate = useNavigate();
  const { id } = useParams();
  const [crop, setCrop] = useState();
  const [cropLoading, setCropLoading] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState(null);
  const [isUsed, setIsUsed] = useState(false);
  const [image, setImage] = useState(null);
  const [output, setOutput] = useState(null);
  const [file, setFile] = useState(null);
  const { previewData, setFormData } = usePreviewStore();
  const router = useRouter();

  const arr1 = [
    {
      image: scan,
      title: "Scan",
      path: ``,
    },
    {
      image: mannual,
      title: "Manual",
      path: `/preview/${id}?hasSheet=false&leadId=${leadDetail?.leadId}`,
    },
  ];
  const arr1Click = (name) => {
    setSelectedType(name);
    setModelData({ ...modelData, gutterSheetUploadType: name });
    if (name == "Manual") {
      navigate(`/preview/${id}?hasSheet=false&leadId=${leadDetail?.leadId}`);
    }
  };
  function formatTitleCase(text) {
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  const handleAdd = (event) => {
    setOutput(null);
    setFile(null);
    setSrc(null);
    setIsUsed(false);
    const newFiles = event.affectedFiles.map((fileWrapper) =>
      fileWrapper.getRawFile()
    );
    selectImage(newFiles[0]);
    setFile(newFiles[0]);
  };

  const handleRemove = (event) => {
    setFile(null);
    setImgSrc(null);
    setSrc(null);
    setIsUsed(false);
    setOutput(null);
  };
  const selectImage = (file) => {
    if (file) {
      setOutput(URL.createObjectURL(file));
      setSrc(URL.createObjectURL(file));
    }
  };
  function base64ToFile(base64String, filename, mimeType) {
    // Decode the base64 string
    const byteString = atob(base64String.split(",")[1]);

    // Create an array of 8-bit unsigned integers
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }

    // Create a Blob from the byteArray
    const file = new File([byteArray], "myImage", { type: "image/png" });

    return file;
  }

  const handleSubmittoApi = async (selectedFile) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);
    try {
      const response = await axios.post(
        `https://scanapi.mhalt.com/upload/gutter-sheet`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const data = response.data?.data?.full_analysis;
      const measurementes = response.data.data.upper_analysis;
      const measurementKeys = Object.keys(
        measurementes.Measurements.Columns["0To12ft"]
      );
      const measurements = measurementKeys.map((key) => ({
        firstStory: measurementes.Measurements.Columns["0To12ft"][key] || "",
        secondStory: measurementes.Measurements.Columns["12To24ft"][key] || "",
        thirdStory: measurementes.Measurements.Columns["Over24ft"][key] || "",
      }));
      const grandTotal = measurements
        .slice(0, 6)
        .reduce((total, measurement) => {
          return (
            total +
            (parseFloat(measurement.firstStory) || 0) +
            (parseFloat(measurement.secondStory) || 0) +
            (parseFloat(measurement.thirdStory) || 0)
          );
        }, 0);
      const porch_ceiling = Array(5).fill({
        location: "",
        length: "",
        width: "",
        squareFeet: "",
      });

      const prsa = porch_ceiling.map((item, index) => {
        return {
          location: data?.PorchCeiling[index]?.Location || "",
          length: data?.PorchCeiling[index]?.Length || "",
          width: data?.PorchCeiling[index]?.Width || "",
          squareFeet: data?.PorchCeiling[index]?.SquareFootage || "",
        };
      });

      const result = [];

      if (measurementes.Measurements.Columns["0To12ft"].IndicatorStatus) {
        result.push("0-12 ft.");
      }
      if (measurementes.Measurements.Columns["12To24ft"].IndicatorStatus) {
        result.push("12.1 ft.- 24ft.");
      }
      if (measurementes.Measurements.Columns["Over24ft"].IndicatorStatus) {
        result.push("24ft.");
      }
      const previewValues = {
        customer: data.CustomerDetails.Customer || "",
        city: data.CustomerDetails.City || "",
        st: data.CustomerDetails.State || "",
        job: data.CustomerDetails.JobNumber || "",
        measurements: measurements,
        gutter_height: result,
        roof_type: [
          typeof data?.RoofAndGutterDetails?.RoofType == "string"
            ? data?.RoofAndGutterDetails?.RoofType?.toUpperCase() == "SHINGLE"
              ? "Asphalt Shingle"
              : formatTitleCase(data.RoofAndGutterDetails.RoofType)
            : "",
        ],
        ribbedRoofQuantity:
          data.RoofAndGutterDetails.RoofType &&
          data.RoofAndGutterDetails.RoofType.toLowerCase() == "ribbed roof"
            ? data.RoofAndGutterDetails.Quantity
            : "",
        color: data.RoofAndGutterDetails.Color || "WHITE",
        gutter_type: data.RoofAndGutterDetails.GutterType || "FS",
        gutter_size: data.RoofAndGutterDetails.GutterSize || "4",
        total_gutter_footage: grandTotal,
        downspout:
          data.RoofAndGutterDetails.DownspoutDetails.DownspoutSize || "2x3",
        downspout_color:
          data.RoofAndGutterDetails.DownspoutDetails.DownspoutColor || "WHITE",
        downspout_footage:
          data.RoofAndGutterDetails.DownspoutDetails.DownspoutFootage || 0,
        aelbows: data.RoofAndGutterDetails.Elbows.NumberAElbows || "",
        belbows: data.RoofAndGutterDetails.Elbows.NumberBElbows || "",
        roundElbows: data.RoofAndGutterDetails.Elbows.NumberRoundElbows || "",
        offsetElbows: data.RoofAndGutterDetails.Elbows.NumberOffsetElbows || "",
        outside: data.RoofAndGutterDetails.Miters.Outside || "",
        gutter_downspout_elbows: data.RoofAndGutterDetails.TotalFootage,
        inside: data.RoofAndGutterDetails.Miters.Inside || "",
        rights: data.RoofAndGutterDetails.EndCaps.Rights || "",
        lefts: data.RoofAndGutterDetails.EndCaps.Lefts || "",
        savers: data.RoofAndGutterDetails.AdditionalParts.SpoutSavers || "",
        straps: data.RoofAndGutterDetails.AdditionalParts.RoofStraps || "",
        wedges: data.RoofAndGutterDetails.AdditionalParts.Wedges || "",
        partial_install: data.RoofAndGutterDetails.PartialInstall || "Yes",
        fascia_replacement: data.FasciaReplacement.ReplacementType || "",
        fascia_total_footage: data.FasciaReplacement.TootalFootage,
        fascia_size: data.FasciaReplacement.Size.CircleOption || "",
        fascia_other_size: data.FasciaReplacement.Size.SizeValue,
        fascia_other: data.FasciaReplacement.wrapType.CircleOption || "",
        // fascia_other_value: data.FasciaReplacement.wrapType.WrapTypeValue || "",
        fascia_color: data.FasciaReplacement.wrapType.WrapTypeValue || "",
        metal_wrapped_color:
          data.FasciaReplacement.wrapType.CircleOption == "Metal Wrapped" &&
          data.FasciaReplacement.Color,
        fascia_type: data.FasciaReplacement.Type || "",
        fascia_wrap:
          (typeof data.FasciaReplacement.NewWrapFootage == "string"
            ? Number(data.FasciaReplacement.NewWrapFootage)
            : data.FasciaReplacement.NewWrapFootage) || 0,
        soffit_replacement: data.SoffitReplacement.ReplacementType || "",
        soffit_total_footage: data.SoffitReplacement.TotalFootage,
        soffit_other: data.SoffitReplacement.Material.CircleOption || "",
        soffit_other_value: data.SoffitReplacement.Material.MaterialValue || "",
        soffit_color: data.SoffitReplacement.Color || "None",
        porch_ceiling: prsa,
        files: [],
        images: [],
      };
      setLoading(false);
      setFormData(previewValues);
      router.push(`/preview/${id}?hasSheet=false&leadId=${leadDetail.leadId}`);
    } catch (error) {
      setLoading(false);
      toast.error(
        "Your choosen image is not recognized by the system please select different image"
      );
    }
  };

  const cropImageNow = () => {
    setCropLoading(true);
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    // Adjust canvas size for high resolution
    const pixelRatio = window.devicePixelRatio;
    const qualityMultiplier = 5;
    let effectiveRatio = pixelRatio * qualityMultiplier;

    canvas.width = crop.width * effectiveRatio;
    canvas.height = crop.height * effectiveRatio;

    const ctx = canvas.getContext("2d");

    // Set transformation for high-quality scaling
    ctx.setTransform(effectiveRatio, 0, 0, effectiveRatio, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    // Draw the cropped image
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    // Export to PNG
    let base64Image = canvas.toDataURL("image/png");
    let imageSizeKB = base64Image.length / 1024;

    // Downscale if size exceeds 4MB
    while (imageSizeKB > 4000 && effectiveRatio > 1) {
      effectiveRatio *= 0.9; // Reduce the ratio by 10%
      canvas.width = crop.width * effectiveRatio;
      canvas.height = crop.height * effectiveRatio;

      ctx.setTransform(effectiveRatio, 0, 0, effectiveRatio, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      base64Image = canvas.toDataURL("image/png");
      imageSizeKB = base64Image.length / 1024;
    }

    if (imageSizeKB <= 4000) {
      setOutput(base64Image);
      setCropLoading(false);
      setIsUsed(true);
    } else {
      setCropLoading(false);
      console.error("Failed to generate an image under 4MB.");
    }
  };
  return (
    <>
      <div
        style={{ paddingTop: "10px" }}
        className={isMobile ? "" : "k-scrollable"}
      >
        {leadDetail.mhalt ? (
          <div style={{ marginBottom: isMobile ? "50px" : "" }}>
            {leadDetail.gutterSheet ? (
              <h2 className="k-font-normal k-mt-4">
                The gutter sheet has been successfully uploaded.{" "}
                <a
                  href={`/preview/${leadDetail._id}?hasSheet=true&leadId=${leadDetail.leadId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                    textDecoration: "none",
                    listStyle: "none",
                    color: "black",
                  }}
                >
                  Click here to view it.
                </a>
              </h2>
            ) : (
              <h2>You don't have a gutter sheet uploaded.</h2>
            )}
          </div>
        ) : (
          <>
            {leadDetail?.gutterSheetDraft ? (
              <div className="">
                <h2 className="k-font-normal k-mt-4">
                  You have a gutter sheet saved as a draft. Please submit it or
                  make any necessary edits.
                </h2>
                <div
                  className={`k-display-flex k-justify-content-end k-mt-8 ${
                    !isMobile && "k-mb-2"
                  } k-fixed-footer`}
                >
                  <Button
                    type="button"
                    className="k-mr-2 k-button-red2"
                    size={isMobile ? "small" : "large"}
                    onClick={() => setModelData({ ...modelData, open: false })}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      router.push(
                        `/preview/${leadDetail._id}?hasSheet=false&leadId=${leadDetail.leadId}`
                      );
                    }}
                    type="button"
                    className="k-mr-2 k-button-green"
                    size={isMobile ? "small" : "large"}
                  >
                    Edit Draft
                  </Button>
                </div>
              </div>
            ) : !uploadGutterSheet ? (
              <div className="k-text-center">
                <h2 className="k-font-normal k-mt-4">
                  Does this job require Gutter Sheet?
                </h2>
                <div
                  className={`k-display-flex k-md-gap-less k-justify-content-center k-gap-20 k-mt-10 k-px-8`}
                >
                  <div
                    onClick={() => {
                      setModelData({ ...modelData, isGutterSheet: false });
                      nextStep();
                    }}
                    className="k-text-center"
                  >
                    <div
                      className={`${
                        isMobile ? "k-py-4 k-px-10" : "k-py-8 k-px-16"
                      }  k-elevation-1 k-rounded-lg k-cursor-pointer`}
                      style={{ color: "#FFFFFF" }}
                    >
                      <img height={64} width={64} alt="img" src={cross} />
                    </div>
                    <h2 className="k-font-bold k-mt-5 k-sm-sub-heading">No</h2>
                  </div>

                  <div
                    onClick={() => {
                      setModelData({ ...modelData, isGutterSheet: true });
                      setUploadGutterSheet(true);
                    }}
                    className="k-text-center"
                  >
                    <div
                      className={`${
                        isMobile ? "k-py-4 k-px-10" : "k-py-8 k-px-16"
                      } k-elevation-1 k-rounded-lg k-cursor-pointer`}
                      style={{ color: "#FFFFFF" }}
                    >
                      <img height={64} width={64} alt="img" src={tick} />
                    </div>
                    <h2 className="k-font-bold k-mt-5 k-sm-sub-heading">Yes</h2>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="k-text-center">
                  <h1 className="k-font-semibold k-sm-heading">
                    {selectedType != "Scan"
                      ? "Choose Entry Method"
                      : file
                      ? "Crop Image"
                      : "Choose Image"}
                  </h1>
                  <h4 className="k-font-normal k-mt-4">
                    {selectedType != "Scan"
                      ? "Select an option to proceed with your document submission"
                      : file
                      ? "Please ensure that the image you upload contains only the paper and no other objects or backgrounds"
                      : `Please upload the Gutter Sheet Image`}
                  </h4>
                </div>
                {selectedType != "Scan" && (
                  <div
                    className={`k-display-flex k-md-gap-less k-justify-content-center k-gap-20 k-mt-10 k-px-8`}
                  >
                    {arr1.map((item) => (
                      <EntryCard
                        handleClick={arr1Click}
                        handleOpen={() => {}}
                        item={item}
                      />
                    ))}
                  </div>
                )}
                {selectedType == "Scan" && (
                  <>
                    <div
                      className={`k-display-flex k-gap-5 ${styles.uploaderContainer}`}
                      style={{ width: "100%" }}
                    >
                      <Upload
                        accept="image/*"
                        batch={false}
                        multiple={false}
                        defaultFiles={[]}
                        withCredentials={false}
                        saveUrl={
                          "https://demos.telerik.com/kendo-ui/service-v4/upload/save"
                        }
                        removeUrl={
                          "https://demos.telerik.com/kendo-ui/service-v4/upload/remove"
                        }
                        onAdd={handleAdd}
                        onRemove={handleRemove}
                      />
                    </div>
                    {file && (
                      <div
                        className={`k-display-flex k-md-flex-column k-md-gap-less k-justify-content-center k-gap-20 k-mt-2`}
                      >
                        <div>
                          <div className="k-display-flex k-justify-content-between">
                            <h2 className="k-m-0 k-pb-2">Image</h2>
                            <div className="">
                              <Button
                                type="button"
                                className="k-button-green k-mb-2"
                                size="large"
                                disabled={cropLoading}
                                style={{ width: "100px" }}
                                primary={true}
                                onClick={cropImageNow}
                              >
                                {cropLoading ? "Croping" : "Crop"}
                              </Button>
                            </div>
                          </div>
                          {src && (
                            <ReactCrop
                              src={src}
                              onImageLoaded={setImage}
                              crop={crop}
                              onChange={setCrop}
                            />
                          )}
                        </div>

                        <div>
                          <h2 className="k-m-0 k-pb-2 k-mb-3">Result</h2>
                          <div>
                            {output && (
                              <img
                                className="myCanvusandImage2"
                                height={500}
                                src={output}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
      {selectedType == "Scan" &&
        !leadDetail.gutterSheet &&
        !leadDetail.gutterSheetDraft && (
          <div className="k-display-flex k-justify-content-end k-mt-8 k-mb-2">
            <Button
              disabled={loading}
              style={{ width: "100px" }}
              primary={true}
              className="k-button-red2 k-mr-2"
              size="large"
              type="button"
              onClick={() => {
                setSelectedType(null);
                setIsUsed(false);
                setFile(null);
                setImgSrc(null);
              }}
            >
              Back
            </Button>
            <Button
              type="button"
              style={{ width: "100px" }}
              primary={true}
              onClick={() => {
                if (isUsed) {
                  const myfile = base64ToFile(output);
                  if (!myfile) {
                    return toast.error("Please Choose The Image");
                  } else {
                    handleSubmittoApi(myfile);
                  }
                } else {
                  if (!file) {
                    return toast.error("Please Choose The Image");
                  } else {
                    convertPngToJpeg(file)
                      .then((processedFile) => {
                        handleSubmittoApi(processedFile);
                      })
                      .catch((error) => {
                        toast.error(
                          "Facing issue while processing png image, please upload jpeg image"
                        );
                      });
                  }
                }
              }}
              disabled={loading}
              className="k-button-green k-mr-2"
              size="large"
            >
              {loading ? (
                <>
                  <Loader
                    size="small"
                    type="converging-spinner"
                    style={{ color: "white" }}
                  />{" "}
                  Scaning
                </>
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        )}
    </>
  );
};

export default GutterSheet;
